module.exports = __webpack_public_path__ + "static/media/BG_11.e2040eed.png";